export default "__VITE_ASSET__dqlHmQ$V__"